export * from './simple-layout.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/containers/simple-layout/index.ts